import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { setRangeValue } from "../../../../Utils/NumberUtils";
export var TiltAnimation = /*#__PURE__*/function () {
  function TiltAnimation() {
    _classCallCheck(this, TiltAnimation);
    this.enable = false;
    this.speed = 0;
    this.sync = false;
  }
  _createClass(TiltAnimation, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      if (data.speed !== undefined) {
        this.speed = setRangeValue(data.speed);
      }
      if (data.sync !== undefined) {
        this.sync = data.sync;
      }
    }
  }]);
  return TiltAnimation;
}();